const getConfig = require('./utils/config');

// TODO: Change the path from `ebanking.portfolios` to `ebanking`
// once apservices.json has been updated on all environments
module.exports = getConfig('apiservices', 'ebanking.portfolios', {
  baseUrl: 'https://sinasebankd1.sg.db.com:8243'
});

